<template>
    <div ref="elementRef">
        <slot :viewed="viewed"/>
    </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeUnmount, ref, useTemplateRef } from 'vue';

const props = defineProps({
    offset: {
        type: Number,
        required: false,
        default: 0
    },
    threshold: {
        type: Number,
        required: false,
        default: 1.0
    },
    keepObserving: {
        type: Boolean,
        required: false
    }
});

const viewed = ref<boolean>(false);
const elementRef = useTemplateRef<HTMLElement | null>('elementRef');
const emit = defineEmits(['visible', 'hidden']);

let observer: IntersectionObserver | null = null;
function observe(): void {
    const options: IntersectionObserverInit = { rootMargin: `${props.offset}px`, threshold: props.threshold };
    observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                viewed.value = true;
                emit('visible');
                if (!props.keepObserving) {
                    unObserve();
                }
            } else {
                emit('hidden');
            }
        });
    }, options);
    if (elementRef.value) {
        observer.observe(elementRef.value);
    }
}

function unObserve(): void {
    if (observer) {
        observer.unobserve(elementRef.value!);
        observer.disconnect();
        observer = null;
    }
}

onMounted(observe);
onBeforeUnmount(unObserve);
</script>
